import React, {useEffect, useState} from 'react'
import {useLocation} from "react-router-dom";
import "./scorerRedirect.css";

const WARTEZEIT_SEKUNDEN = 10;

// Umfang des Countdown-Rings (Radius 52) für stroke-dasharray
const RING_UMFANG = 2 * Math.PI * 52;

export default function ScorerRedirect() {

    const urlParams = new URLSearchParams(useLocation().search);
    const type = urlParams.get('type');
    const url = type === "test" ? "https://client.darthelfer.de" : "https://scorer.darthelfer.de";

    const [timerCounter, setTimerCounter] = useState(WARTEZEIT_SEKUNDEN);

    useEffect(() => {
        if (timerCounter <= 0) {
            // im Effekt statt beim Rendern, damit nur einmal weitergeleitet wird
            window.open(url, "_self");
            return;
        }
        const timeoutId = setTimeout(() => setTimerCounter(timerCounter - 1), 1000);
        return () => clearTimeout(timeoutId);
    }, [timerCounter]);

    const anteilVergangen = (WARTEZEIT_SEKUNDEN - timerCounter) / WARTEZEIT_SEKUNDEN;

    return <div className="dhsr-seite">
        <main className="dhsr-karte">
            <img className="dhsr-logo" alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"}/>

            <div className="dhsr-ring" role="timer" aria-live="off" aria-label={"Weiterleitung in " + timerCounter + " Sekunden"}>
                <svg viewBox="0 0 120 120" aria-hidden="true">
                    <circle className="dhsr-ring-spur" cx="60" cy="60" r="52"/>
                    <circle className="dhsr-ring-fortschritt" cx="60" cy="60" r="52"
                            strokeDasharray={RING_UMFANG} strokeDashoffset={RING_UMFANG * (1 - anteilVergangen)}/>
                </svg>
                <div className="dhsr-ring-zahl">
                    <b>{Math.max(timerCounter, 0)}</b>
                    <small>Sek.</small>
                </div>
            </div>

            <h1 className="dhsr-titel">Der Scorer wird aktualisiert</h1>
            <p className="dhsr-text">Bitte einen Moment Geduld, du wirst gleich automatisch weitergeleitet.</p>
        </main>
    </div>
}
